// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;
globalThis["_sentryRewritesTunnelPath"] = "/monitoring";
globalThis["SENTRY_RELEASE"] = { "id": "QO8mBRIuL7C5Rw8FLEYMW" };
globalThis["_sentryBasePath"] = undefined;
globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";
import * as Sentry from '@sentry/nextjs';
Sentry.init({
    dsn: 'https://a3eec040b50c5bc07dcddae21e2fc38b@o4508003300868096.ingest.us.sentry.io/4508003303620608',
    // Add optional integrations for additional features
    // eslint-disable-next-line import/namespace
    integrations: [Sentry.replayIntegration()],
    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    enabled: process.env.NEXT_PUBLIC_ENV !== 'LOCAL',
});
